import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import LavorisService from "../../services/LavorisService";
import { TableActions } from "../../components/others/TableActions/index";
import AddApplicant from "../others/addApplicant/index";
import EditApplicant from "../others/editApplicant/index";
import Promotion from "../others/promotion/Promotion";
import EliminarModal from "../../components/others/EliminarModal";
import { useModal } from "../../hooks";
import { RootState } from "../../store/combineReducer";
import { useSelector } from "react-redux";
import { AfterPromotionModal } from "../../components/others/AfterPromotionModal";
import { useAlert } from "../../hooks/useAlert";
import { getErrorMessage } from "../../utils";
import ImportAplicantsModal from "../others/importAplicantsModal";
import { PhoneNumber } from "../../utils/phoneNumber";
import applicantsExcelReport from "./applicantsExcelReport";
import InfoOffcanvas from '../../components/others/InfoOffCanvas/InfoOffCanvas';
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import "./applicants_header.scss";

const POSTULANTES = () => {
  const LavorisInstance = LavorisService.getInstance();
  const user = useSelector((state: RootState) => state.user);
  const chosenCompany = user.currentCompany || user.companies[0]
  const chosenRole: string = user?.currentRole;

  const { showAlert } = useAlert();
  const [data, setData] = useState<any[]>([]);
  const [hasMore, setHasMore] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const hasSearchQuery = searchQuery && searchQuery.length > 0
  const [items, setItems] = useState({
    itemsPerPage: 20,
    page: 1,
  });
  const [chosenApplicant, setChosenApplicant] = useState('')
  const [selectedApplicants, setSelectedApplicants] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const { openModal, closeModal, isActive } = useModal();
  const controller = new AbortController();
  const signal = controller.signal;
  const [searchParams, setSearchParams,] = useSearchParams("");
  const [tableKey, setTableKey] = useState(0);

  const getAllApplicantsCall = async () => {
    setIsLoading(true)
    try {
      const applicants = await LavorisInstance.CompanyServices.getCandidatesOfCurrentCompanyPagination(
        chosenCompany.id,
        signal,
        items.itemsPerPage,
        items.page,
        hasSearchQuery ? searchQuery : ""
      );

      if (applicants.length === 0) {
        setHasMore(false);
        return;
      }
      const existingIds = new Set(data?.map(item => item.id));
      const uniqueAplicants = applicants?.filter(applicant => !existingIds.has(applicant.id));

      setData(prevData => [...prevData, ...uniqueAplicants]);
      setItems(prev => ({ ...prev, page: prev.page + 1 }));

    } catch (error: any) {
      console.log(error);
      setHasMore(false);
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    getAllApplicantsCall()
  }, [])

  useEffect(() => {
    return () => {
      controller.abort();
    };
  }, [])

  const getAplicantsCallRefresh = async () => {
    setIsLoading(true);

    try {
      setHasMore(true);
      // Limpiar los datos primero
      setData([]);
      setItems({ itemsPerPage: 20, page: 1 });
      
      const applicants = await LavorisInstance.CompanyServices.getCandidatesOfCurrentCompanyPagination(
        chosenCompany.id,
        signal,
        items.itemsPerPage,
        1,
        hasSearchQuery ? searchQuery : ""
      );

      if (applicants.length === 0) {
        setHasMore(false);
        setData([]);
        return;
      }

      // Actualizar los datos en una sola operación
      setData(applicants);
      setItems(prev => ({ ...prev, page: 2 }));
      // Forzar re-render de la tabla
      setTableKey(prev => prev + 1);
    } catch (error) {
      console.log(error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }

  }

  const searchWitQuery = async () => {
    setIsLoading(true);
    try {
      setData([])
      const applicants = await LavorisInstance.CompanyServices.getCandidatesOfCurrentCompanyPagination(
        chosenCompany.id,
        signal,
        items.itemsPerPage,
        1,
        hasSearchQuery ? searchQuery : ""
      );

      if (applicants?.length === 0) {
        showAlert("No se encontraron registros");
        return
      } else {
        setData(applicants);
        setItems(prev => ({ ...prev, page: prev.page + 1 }));
        setHasMore(true);
      }
    } catch (error) {
      console.log(error);
      setHasMore(false);
    } finally {
      setIsLoading(false);
    }
  };

  const onSearch = async () => {
    try {
      if (hasSearchQuery) {
        await searchWitQuery()
      } else {
        await getAplicantsCallRefresh()
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const querySearch = e.target.value;
    setSearchQuery(querySearch);
  };

  const HandleDeletion = async () => {
    setIsLoading(true)
    try {
      let ApplicantID = searchParams.get('rowId')
      await LavorisInstance.CompanyServices.deleteApplicant(ApplicantID || "")
      closeModal("EliminateModal")
      await getAplicantsCallRefresh()
    } catch (err) {
      showAlert(getErrorMessage({ title: 'No se pudo eliminar al candidato', err }))
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }

  const getAllApplicants = async () => {
    setExcelLoading(true)
    try {
      const employees = await LavorisInstance.CompanyServices.getAllApplicants();
      await applicantsExcelReport(employees);
    } catch (err) {
      console.log(err)
      showAlert(getErrorMessage({ title: 'error al descargar excel', err }))
    } finally {
      setExcelLoading(false)
    }
  }

  // Configuración de columnas para la tabla
  const applicantColumns = [
    {
      key: 'selection',
      title: '',
      className: 'col-selection',
      expandable: false,
      width: '40px',
      fixed: true,
      render: (value: any, row: any) => (
        chosenRole !== 'CANDIDATE_APPOINTMENTS' ? (
          <input
            type="checkbox"
            checked={selectedApplicants.some(applicant => applicant?.id === row?.id)}
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedApplicants([...selectedApplicants, row]);
              } else {
                setSelectedApplicants(
                  selectedApplicants.filter(applicant => applicant?.id !== row?.id)
                );
              }
            }}
            className="form-check-input"
          />
        ) : null
      )
    },
    {
      key: 'name',
      title: 'Apellido, Nombre',
      className: 'col-name',
      expandable: false,
      render: (value: string) => value?.toUpperCase() || "No disponible"
    },
    {
      key: 'DNI',
      title: 'DNI',
      className: 'col-dni',
      responsive: 'tablet' as const,
      expandable: false
    },
    {
      key: 'phoneNumber',
      title: 'Teléfono',
      className: 'col-phone',
      responsive: 'desktop' as const,
      expandable: false,
      render: (value: string) => PhoneNumber(value) || "No disponible"
    },
    {
      key: 'email',
      title: 'Email',
      className: 'col-email',
      expandable: false,
      render: (value: string) => value?.toLowerCase() || "No disponible"
    },
    {
      key: 'isActive',
      title: 'Activo',
      className: 'col-status',
      expandable: false,
      render: (value: boolean) => value ? 'Sí' : 'No'
    },
    {
      key: 'actions',
      title: 'Acciones',
      className: 'col-actions',
      expandable: false,
      render: (value: any, row: any) => (
        <div className="d-flex gap-1 justify-content-center">
          <TableActions
            type="View"
            onClick={() => openModal("ViewModal", row?.id, { readOnly: true })}
          />
          <TableActions
            type="Edit"
            onClick={() => {
              setItems({ itemsPerPage: 20, page: 1 });
              openModal("modalEditApplicant", row?.id, { readOnly: false });
            }}
          />
          <TableActions
            type="Delete"
            onClick={() => {
              setItems({ itemsPerPage: 20, page: 1 });
              setChosenApplicant(row?.name)
              openModal("EliminateModal", row.id);
            }}
          />
        </div>
      )
    }
  ];

  return (
    <div className="main-container applicants-page">
      <div className="atendoo-card">
        {/* Header Section */}
        <div className="custom-header">
          <div className="header-top">
            <h6 className="subtitle">Postulantes</h6>
            <InfoOffcanvas title="INFORMACIÓN DE TABLA">
              <ul>
                <li>La primera carga la tabla muestra los primeros 20 resultados.</li>
                <li>Se puede buscar con apellido, nombre o dni</li>
                <li>A medida que se va haciendo scroll para abajo, la tabla va buscando más resultados.</li>
              </ul>
            </InfoOffcanvas>
          </div>

          <div className="header-controls">
            {/* Search Section */}
            <div className="search-section">
              <div className="search-input-group">
                <input
                  title="Ingresar dni o apellido"
                  type="search"
                  placeholder="Buscar por apellido, nombre o DNI..."
                  className="search-input"
                  onChange={handleSearchChange}
                />
                <button
                  type="button"
                  className="search-btn"
                  onClick={() => {
                    setItems({
                      itemsPerPage: 20,
                      page: 1,
                    });
                    onSearch()
                  }}
                  title="Buscar"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667ZM14 14l-2.9-2.9"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              </div>
            </div>

            {/* Actions Section */}
            <div className="actions-section">
              {/* Results Count */}
              <div className="results-count">
                <span className="count-number">{data.length}</span>
                <span className="count-label">postulantes</span>
              </div>

              {/* Download Button */}
              <button
                className="download-btn"
                onClick={getAllApplicants}
                title="Descargar reporte de todos los postulantes"
                disabled={excelLoading}
              >
                {excelLoading ? (
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                  </div>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M14 10v2.667A1.333 1.333 0 0112.667 14H3.333A1.333 1.333 0 012 12.667V10M8 10.667L8 2M8 10.667l-2.667-2.666M8 10.667l2.667-2.666"
                      stroke="currentColor"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                )}
                <span className="btn-text">Excel</span>
              </button>

              {/* Add Applicant Button */}
              {!isLoading && (
                <button
                  type="button"
                  className="add-btn"
                  onClick={() => {
                    setItems({ itemsPerPage: 20, page: 1 });
                    openModal("modalAddApplicant")
                  }}
                  title="Agregar postulante"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M8 3.333v9.334M3.333 8h9.334"
                      stroke="currentColor"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="btn-text">Agregar</span>
                </button>
              )}

              {/* Import Button */}
              {!isLoading && (
                <button
                  className="import-btn"
                  onClick={() => {
                    setItems({ itemsPerPage: 20, page: 1 });
                    openModal("ImportAplicantsModal")
                  }}
                  title="Importar postulantes"
                >
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path
                      d="M14 10v2.667A1.333 1.333 0 0112.667 14H3.333A1.333 1.333 0 012 12.667V10M5.333 6.667L8 4l2.667 2.667M8 4v8"
                      stroke="currentColor"
                      strokeWidth="1.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span className="btn-text">Importar</span>
                </button>
              )}

              {/* Promote Button */}
              {chosenRole !== 'CANDIDATE_APPOINTMENTS' && !isLoading && (
                selectedApplicants.length > 0 ? (
                  <button
                    className="promote-btn"
                    onClick={() => {
                      setItems({ itemsPerPage: 20, page: 1 });
                      const applicants: string[] = selectedApplicants.map(({ id }) => id);
                      selectedApplicants.length === 1
                        ? setSearchParams({
                          modalPromotion: "active",
                          candidates: applicants,
                          name: selectedApplicants?.[0]?.name,
                        })
                        : setSearchParams({
                          modalPromotion: "active",
                          candidates: applicants.join(","),
                        });
                    }}
                    title="Promover a empleado"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M4.667 6L8 2.667 11.333 6M8 2.667v10.666"
                        stroke="currentColor"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="btn-text">Promover ({selectedApplicants.length})</span>
                  </button>
                ) : (
                  <button
                    disabled
                    className="promote-btn"
                    title="Selecciona postulantes para promover"
                  >
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path
                        d="M4.667 6L8 2.667 11.333 6M8 2.667v10.666"
                        stroke="currentColor"
                        strokeWidth="1.3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                    <span className="btn-text">Promover</span>
                  </button>
                )
              )}

              {/* Loading Indicator */}
              {isLoading && (
                <div className="loading-indicator">
                  <div className="loading-spinner">
                    <div className="spinner"></div>
                  </div>
                  <span>Cargando...</span>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Table Section */}
        <InfiniteTable
          key={tableKey}
          data={data}
          columns={applicantColumns}
          loading={isLoading}
          hasMore={hasMore}
          onLoadMore={getAllApplicantsCall}
          height={470}
          emptyMessage="Momentáneamente no hay postulantes cargados para mostrar"
          loadingMessage={data.length === 0 ? "Cargando postulantes..." : "Buscando postulantes..."}
          striped
          hover
          bordered
        />

        {/* Modals */}
        {isActive("modalAddApplicant") && (
          <AddApplicant
            urlTittle={"modalAddApplicant"}
            onClose={() => closeModal("modalAddApplicant")}
            refreshFunction={async () => await getAplicantsCallRefresh()}
            toggleModal
          />
        )}

        {isActive("ImportAplicantsModal") && (
          <ImportAplicantsModal
            show
            urlTittle={"ImportAplicantsModal"}
            onClose={() => closeModal("ImportAplicantsModal")}
            modalTitle={"Importar Postulantes"}
            refreshFunction={() => {
              closeModal("ImportAplicantsModal")
              getAplicantsCallRefresh()
            }}
          />
        )}

        {isActive("modalPromotion") && (
          <Promotion
            toggleModal
            urlTittle={"modalPromotion"}
            onClose={() => {
              setSearchParams({ modalPromotion: "hidden" })
              setSelectedApplicants([])
            }}
          />
        )}

        {isActive("afterPromoted") && (
          <AfterPromotionModal
            urlTittle="afterPromoted"
            show
            onClose={async () => {
              closeModal("afterPromoted");
              // Limpiar selección antes de actualizar
              setSelectedApplicants([]);
              // Esperar un momento para que el modal se cierre completamente
              await new Promise(resolve => setTimeout(resolve, 100));
              // Actualizar la lista
              await getAplicantsCallRefresh();
            }}
          />
        )}

        {isActive("modalEditApplicant") && (
          <EditApplicant
            urlTittle={"modalEditApplicant"}
            onClose={() => closeModal("modalEditApplicant")}
            refreshFunction={() => getAplicantsCallRefresh()}
            toggleModal
            modalTitle="Editar Postulante"
          />
        )}

        {isActive("ViewModal") && (
          <EditApplicant
            urlTittle={"ViewModal"}
            onClose={() => closeModal("ViewModal")}
            refreshFunction={() => getAplicantsCallRefresh()}
            toggleModal
            modalTitle="Ver Postulante"
          />
        )}

        {isActive("EliminateModal") && (
          <EliminarModal
            toggleModal
            name={chosenApplicant ? chosenApplicant : ""}
            handleDeletion={() => HandleDeletion()}
            urlTittle={"EliminateModal"}
            isLoading={isLoading}
          />
        )}
      </div>
    </div>
  );
};

export default POSTULANTES;